import * as React from 'react'
import './index.scss'
import { AccordionProps } from './types'
import { Icon } from '@petz/ds-icon'
import { SegmentContext } from '../../hooks/SegmentContext'

export const Accordion: React.FC<AccordionProps> = ({ title, description, kindTitle }: AccordionProps) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const safeTitle = title ?? 'Título do accordion'
  const safeDescription = description ?? ''
  const safeKindTitle = kindTitle ?? ''

  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const renderDescription = (text: string) => {
    return text.replace(/(\bhttps?:\/\/[^\s,()]+|\bwww\.[^\s,()]+)/g, (match) => {
      const hasPeriod = match.endsWith('.')
      const link = hasPeriod ? match.slice(0, -1) : match
      const punctuation = hasPeriod ? '.' : ''

      const redirect = link.startsWith('www') ? 'https://' + link : link

      return `<a href="${redirect}" style="color: #337ab7; text-decoration: underline !important;" className="accordion-link" target="_blank" rel="noopener noreferrer">${link}</a>${punctuation}`
    })
  }

  function handleHeaderClick() {
    if (!isOpen) {
      segmentTrack('Help Option Clicked', { widget: true, alt_text: 'ajuda-alt', help_section: 'Dúvidas frequentes', help_subsection: safeKindTitle, button_name: safeTitle })
    }
    setIsOpen(!isOpen)
  }

  return (
    <div className={`accordion-container ${isOpen ? 'open' : ''}`}>
      <button className="accordion-header" onClick={handleHeaderClick}>
        <h2 className="accordion-title">{safeTitle}</h2>
        <Icon className="accordion-icon" size={'lg'} name={isOpen ? 'minus' : 'plus'} variant="line" />
      </button>
      <p className="accordion-body" dangerouslySetInnerHTML={{ __html: renderDescription(safeDescription) }} />
    </div>
  )
}
